export default __webpack_public_path__ + "static/media/Aiko.4a6ba373.png";